import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../enter/enter";
const MainTwkel = ({ userData }) => {
  const [key, setKey] = useState("enter");
  const [NameMowakel, setNameMowakel] = useState("");
  const [SefaMowakel, setSefaMowakel] = useState("");
  const [NameWakel, setNameWakel] = useState("");
  const [NumberTawkel, setNumberTawkel] = useState("");
  const [Cahr, setCahr] = useState("");
  const [Year, setYear] = useState("");
  const [TypeTwakel, setTypeTwakel] = useState("");
  const [Gehaa, setGehaa] = useState("");
  const [DateTawkel, setDateTawkel] = useState("");
  const [Gharad, setGharad] = useState("");
  const [TawkelID, setTawkelID] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [Note, setNote] = useState("");
  const [NoteImg, setNoteImg] = useState("");
  const [TawkelStatus, setTawkelStatus] = useState("");

  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة التوكيلات</h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title="بيانات التوكيل">
                <Enter
                  NoteImg={NoteImg}
                  setNoteImg={setNoteImg}
                  userData={userData}
                  setTawkelID={setTawkelID}
                  setSelectedFile={setSelectedFile}
                  selectedFile={selectedFile}
                  TawkelID={TawkelID}
                  key={key}
                  setKey={setKey}
                  NameMowakel={NameMowakel}
                  setNameMowakel={setNameMowakel}
                  SefaMowakel={SefaMowakel}
                  setSefaMowakel={setSefaMowakel}
                  NameWakel={NameWakel}
                  setNameWakel={setNameWakel}
                  NumberTawkel={NumberTawkel}
                  setNumberTawkel={setNumberTawkel}
                  Cahr={Cahr}
                  setCahr={setCahr}
                  Year={Year}
                  setYear={setYear}
                  TypeTwakel={TypeTwakel}
                  setTypeTwakel={setTypeTwakel}
                  Gehaa={Gehaa}
                  setGehaa={setGehaa}
                  DateTawkel={DateTawkel}
                  setDateTawkel={setDateTawkel}
                  Gharad={Gharad}
                  setGharad={setGharad}
                  TawkelStatus={TawkelStatus}
                  setTawkelStatus={setTawkelStatus}
                  Note={Note}
                  setNote={setNote}
                />
              </Tab>
              {/* <Tab eventKey="display" title="عرض">
            <Display/>
                </Tab> */}
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default MainTwkel;
